import { Injectable } from '@angular/core';
import { AbstractGraphqlRequest, GraphqlRequestType } from '@ckmk/angular';
import { TypedDocumentNode } from '@apollo/client';
import { PostCategoryModel } from '@app/src/app/modules/post/classes/category/model/post.category.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class PostCategoryRequestMutation extends AbstractGraphqlRequest<PostCategoryModel> {
  protected override type: GraphqlRequestType = 'mutation';

  protected override getQuery(payload: any): TypedDocumentNode<any, any> {
    if (payload.data?.id) {
      return gql`
        mutation updatePostCategory($data: PostCategoryUpdateInput!) {
          updatePostCategory(data: $data) {
            id
            cover {
              id
              name
              originalName
              extension
              active
              title
              description
              directory
              directories
              chunkEnd
              chunkStart
              frontUrls

              mimetype
              temp
              createdAt
              updatedAt
              createdBy
              updatedBy
            }
            slug
            title
            description
            active
            createdAt
            updatedAt
            deletedAt
            createdBy
            updatedBy
          }
        }
      `;
    }

    return gql`
      mutation createPostCategory($data: PostCategoryCreateInput!) {
        createPostCategory(data: $data) {
          id
          cover {
            id
            name
            originalName
            extension
            active
            title
            description
            directory
            directories
            chunkEnd
            chunkStart
            frontUrls

            mimetype
            temp
            createdAt
            updatedAt
            createdBy
            updatedBy
          }
          slug
          title
          description
          active
          createdAt
          updatedAt
          deletedAt
          createdBy
          updatedBy
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    const categoryData = data.createPostCategory || data.updatePostCategory;

    if (categoryData) {
      return new PostCategoryModel(categoryData);
    }

    return null;
  }
}
